"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.map");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var _default = {
  name: 'side-nav',
  data: function data() {
    return {
      isActive: !(_jsCookie["default"].get('frame.styleguide_drawer') === 'false'),
      menu: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.menu = _toConsumableArray(document.querySelectorAll('.sg-content-section')).map(function (section) {
      return {
        title: section.id,
        links: _toConsumableArray(section.querySelectorAll('.sg-content-block')).map(function (template) {
          return template.dataset.title;
        })
      };
    });
    this.$root.$on('navigation:toggle', function () {
      _this.toggleMenu();
    });
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.isActive = !this.isActive;

      _jsCookie["default"].set('frame.styleguide_drawer', this.isActive, 150, '/', Shopify.shop);
    },
    toggleContent: function toggleContent(title) {
      this.$root.$emit('updateView', title);

      if (!window.matchMedia('(min-width: 576px)').matches) {
        this.isActive = false;
      }
    }
  }
};
exports["default"] = _default;